<template>
  <div>
    <!-- PC, タブレット -->
    <div class="pc-block">
      <div class="lbPlanSelectBoxes">
        <!-- サブスクプラン -->
        <template v-if="hasSubscPlan">
          <h3 class="lbPlanSelectTitle">定額受講</h3>
          <dl class="lbPlanSelectSize">
            <div class="planSelectDescBox">
              <div
                @click="selectSubscPlan(plan.id)"
                class="lbPlanSelectBoxesItem"
              >
                <img :src="plan.image" />
                <div>
                  <h4 :class="{ planSelectDescBoxTitle: true }">
                    {{ plan.name }}
                  </h4>
                  <p class="trial-limit">(有効期間:コース契約期間)</p>
                  <p class="lbPlanSelectAmount lbPlanSelectSubTitle">
                    {{ plan.sub_title }}
                  </p>
                  <p class="lbPlanSelectAmount">
                    <span>月額{{ planPrice }}円(税込) / 名</span>
                    <small>※金額は定価を表示しています。</small>
                  </p>
                </div>
              </div>
            </div>
          </dl>
        </template>

        <!-- 単品LB -->
        <template v-if="hasContents">
          <h3 class="lbPlanSelectTitle">個別受講</h3>

          <dl
            v-for="content in objContent"
            :key="`content-${content.id}`"
            class="lbPlanSelectSize"
          >
            <div class="planSelectDescBox">
              <div
                @click="selectPlan(content.id)"
                class="lbPlanSelectBoxesItem"
              >
                <img :src="content.image" />
                <div>
                  <h4 :class="{ planSelectDescBoxTitle: true }">
                    {{ content.name }}
                  </h4>
                  <p class="trial-limit">
                    (有効期間{{ content.valid_period }}か月)
                  </p>
                  <p class="lbPlanSelectAmount lbPlanSelectSubTitle">
                    {{ content.sub_title }}
                  </p>
                  <p
                    v-for="amount in objAmount"
                    :key="`amount-${amount.id}`"
                    class="lbPlanSelectAmount"
                  >
                    <span v-if="amount.id == content.id">
                      {{ amount.unit_amount }}円(税込) / コース•名
                    </span>
                    <small v-if="amount.id == content.id">
                      ※金額は定価を表示しています。
                    </small>
                  </p>
                  <!-- <p v-for="count in objCount" :key="`count-${count.id}`" class="lbPlanSelectAmount">
                    <span v-if="count.id == content.id">教材数：{{ count.child_count }}コマ</span>
                  </p> -->
                </div>
              </div>
            </div>
          </dl>
        </template>
      </div>
    </div>

    <!-- スマホ -->
    <div class="sp-block">
      <div class="mb20">
        <div>
          <!-- サブスクプラン -->
          <template v-if="hasSubscPlan">
            <h3 class="lbPlanSelectTitleSp">定額受講</h3>
            <div class="planSelectFormItems">
              <div @click="selectSubscPlan(plan.id)">
                <img :src="plan.image" class="lbPlanSelectSp" />
                <h4 :class="{ planSelectDescBoxTitle: true }">
                  {{ plan.name }}
                </h4>
                <p class="trial-limit">(有効期間:コース契約期間)</p>
                <p class="lbPlanSelectAmount lbPlanSelectSubTitle">
                  {{ plan.sub_title }}
                </p>
                <p class="lbPlanSelectAmount">
                  <span>月額{{ planPrice }}円(税込) / 名</span>
                  <small>※金額は定価を表示しています。</small>
                </p>
              </div>
            </div>
          </template>

          <!-- 単品LB -->
          <template v-if="hasContents">
            <h3 class="lbPlanSelectTitleSp">個別受講</h3>
            <div
              v-for="content in objContent"
              :key="`content-${content.id}`"
              class="planSelectFormItems"
            >
              <div @click="selectPlan(content.id)">
                <img :src="content.image" class="lbPlanSelectSp" />
                <h4 :class="{ planSelectDescBoxTitle: true }">
                  {{ content.name }}
                </h4>
                <p class="trial-limit">
                  (有効期間{{ content.valid_period }}か月)
                </p>
                <p class="lbPlanSelectAmount lbPlanSelectSubTitle">
                  {{ content.sub_title }}
                </p>
                <p
                  v-for="amount in objAmount"
                  :key="`amount-${amount.id}`"
                  class="lbPlanSelectAmount"
                >
                  <span v-if="amount.id == content.id">
                    {{ amount.unit_amount }}円(税込) / コース•名
                  </span>
                  <small v-if="amount.id == content.id">
                    ※金額は定価を表示しています。
                  </small>
                </p>
                <!-- <p v-for="count in objCount" :key="`count-${count.id}`" class="lbPlanSelectAmount">
                  <span v-if="count.id == content.id">教材数：{{ count.child_count }}コマ</span>
                </p> -->
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: [
    "subscriptionPlan",
    "subscriptionPrice",
    "contents",
    "amountList",
    "checkoutPersonal",
    "checkoutId",
    "hasContents",
    "hasSubscPlan"
  ],

  data() {
    return {
      plan: this.subscriptionPlan ? JSON.parse(this.subscriptionPlan) : null,
      planPrice: this.subscriptionPrice,
      objContent: JSON.parse(this.contents),
      objAmount: this.amountList
    };
  },

  methods: {
    selectPlan(contenId) {
      if (this.checkoutPersonal == this.checkoutId) {
        axios
          .get("/set-after-login", {
            params: {
              url: "/register/lb_personal_plan?type=" + contenId
            }
          })
          .then(res => {
            window.location.href =
              "/register/lb_personal_plan?type=" + contenId;
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        axios
          .get("/set-after-login", {
            params: {
              url: "/register/lb_corporate_plan?type=" + contenId
            }
          })
          .then(res => {
            window.location.href =
              "/register/lb_corporate_plan?type=" + contenId;
          })
          .catch(error => {
            console.log(error);
          });
      }
    },

    selectSubscPlan(planId) {
      if (this.checkoutPersonal == this.checkoutId) {
        axios
          .get("/set-after-login", {
            params: {
              url: "/register/lb_personal_subsc_plan?type=" + planId
            }
          })
          .then(res => {
            window.location.href =
              "/register/lb_personal_subsc_plan?type=" + planId;
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        axios
          .get("/set-after-login", {
            params: {
              url: "/register/lb_corporate_subsc_plan?type=" + planId
            }
          })
          .then(res => {
            window.location.href =
              "/register/lb_corporate_subsc_plan?type=" + planId;
          })
          .catch(error => {
            console.log(error);
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.is-hidden {
  display: none;
}
.disable {
  color: white !important;
  background-color: #cccccc !important;
  cursor: inherit;
}
.trial-limit {
  text-align: center;
  font-size: 14px;
}
.trialBox {
  height: 60px;
}
.personalBox {
  border: 1px solid #0042bd;
}
.corpolateBox {
  border: 1px solid #30876e;
}
.corpolateTitle {
  color: #30876e;
}
.lbPlanSelectTitle {
  font-size: 1.2rem;
  margin-bottom: 20px;
  font-weight: 700;
}
.lbPlanSelectTitleSp {
  font-size: 1.2rem;
  margin-bottom: 20px;
  font-weight: 700;
  margin-top: 20px;
}
</style>
